import request from 'sb-request'


const search = (query) =>
  request.get(`rest/engine/fr_search`, {
    query: {
      query,
    },
  })


export default {
  search,
}
